<!-- 在线客服左侧列表 -->
<template>
  <div class="leftlist">
    <Card :bordered="false" :padding="0">
      <Tabs v-model="tabName" @on-click="changeTab">
             <TabPane label="待处理" name="1">
                <div style="width:100%;height:50px;background:#e9f7fd;line-height: 50px;">
                  <Input v-model="searchName" placeholder="请输入客户名称搜索" clearable style="width:90%;margin-left: 5%;"/>
                </div>
                <div class="cuslist" :style="tableHeight">
                    <ul class="listul" >
                      <li class="listli" v-for="(item, index) in onlineInfos.filter(itemData => itemData.sessionType != '0' && itemData.name.includes(searchName))" :style="{'background-color':(currentOpenId == item.openId ? '#e3e3e3' : '#fff')}" :key="index" @click= "selectSession(item.openId,item.sessionId,Number(item.leftInfo.unreadCnt))">
                        <div class="firstCE">
                          <div class="channel" >
                              <img v-if="item.sessionChannel == '-7'" src="@/assets/image/online/pcicon.png"/>
                              <img v-if="item.sessionChannel == '-8'" src="@/assets/image/online/WeChaticon.png"/>
                              <img v-if="item.sessionChannel == '-9'" src="@/assets/image/online/Appletsicon.png"/>
                          </div>
                          <div class="cusdialog">
                              <div class="cusname">{{item.leftInfo.value}}</div>
                              <Badge :count="Number(item.leftInfo.unreadCnt)" :overflow-count="99" class="tips"></Badge>
                              <div class="dialogrig" v-if="item.leftInfo.sessionType == '2'" style="color:#e98a36;cursor:auto;">转接会话</div>
                              <div class="dialogrig" v-if="item.leftInfo.sessionType == '3'" style="color:#e98a36;cursor:auto;">多方会话</div>
                          </div>
                        </div>
                        <div class="custext"><b>{{replaceEmoji(item.leftInfo.lastMsg)}}</b></div>
                        <div class="lastfloor">
                            <p class="lasttime">{{timeFormat(item.leftInfo.lastTime)}}</p>
                        </div>
                      </li>
                    </ul>
                </div>
             </TabPane>
             <TabPane label="排队中" name="2">
                <div style="width:100%;height:50px;background:#e9f7fd;line-height: 50px;">
                  <Input v-model="searchName" placeholder="请输入客户名称搜索" clearable style="width:90%;margin-left: 5%;"/>
                </div>
                <div class="cuslist" :style="tableHeight">
                  <ul class="listul">
                      <li class="listli" v-for="(item, index) in onlineInfos.filter(itemData => itemData.sessionType == '0' && itemData.name.includes(searchName))" :key="index">
                        <div class="firstCE">
                          <div class="channel">
                              <img v-if="item.sessionChannel == '-7'" src="@/assets/image/online/pcicon.png"/>
                              <img v-if="item.sessionChannel == '-8'" src="@/assets/image/online/WeChaticon.png"/>
                              <img v-if="item.sessionChannel == '-9'" src="@/assets/image/online/Appletsicon.png"/>
                          </div>
                          <div class="cusdialog">
                              <div class="cusname">{{item.leftInfo.value}}</div>
                              <Badge v-if="false" :count="Number(item.leftInfo.unreadCnt)" :overflow-count="99" class="tips"></Badge>
                              <div class="dialogrig" @click="inviteSession(item.sessionId, item.openId)">邀请会话</div>
                          </div>
                        </div>
                        <div class="custext"><b>{{replaceEmoji(item.leftInfo.lastMsg)}}</b></div>
                        <div class="lastfloor">
                              <p class="lasttime">{{timeFormat(item.leftInfo.lastTime)}}</p>
                              <div class="waittime">排队时长<span>{{formatSeconds(item.leftInfo.queueDuration)}}</span></div>
                        </div>
                      </li>
                    </ul>
                </div>
             </TabPane>
             <TabPane v-if="false" label="浏览中" name="3">
                <div style="width:100%;height:50px;background:#e9f7fd;line-height: 50px;">
                </div>
                <div class="cuslist" :style="tableHeight">
                  <ul class="listul">
                      <li class="listli" v-for="(item, index) in onlineInfos.filter(itemData => itemData.sessionType == '0')" :key="index">
                        <div class="firstCE">
                          <div class="channel">
                              <img v-if="item.channelType == '-7'" src="@/assets/image/online/pcicon.png"/>
                              <img v-if="item.channelType == '-8'" src="@/assets/image/online/WeChaticon.png"/>
                              <img v-if="item.channelType == '-9'" src="@/assets/image/online/Appletsicon.png"/>
                          </div>
                          <div class="cusdialog">
                              <div class="cusname">{{item.value}}</div>

                              <div class="dialogrig" @click="inviteSession(item.sessionId, item.openId)">邀请会话</div>
                          </div>
                        </div>
                        <div class="custext">当前浏览URL:{{item.url}}</div>
                        <div class="lastfloor">
                              <p class="lasttime">{{item.lastTime}}</p>
                              <div class="waittime">浏览时长<span>{{item.browseDuration}}</span></div>
                        </div>
                      </li>
                    </ul>
                </div>
             </TabPane>
      </Tabs>

    <div class="page_style2" v-if="false">
      <Page :total="total" size="small" :page-size='pageSize' :current='currentPage' :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent" @on-page-size-change="changeSize"/>
      <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" /><div style="padding-top: 2px;">页</div>
    </div>
    </Card>
  </div>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
  export default {
    name: "OnlineLeftcon",
    mixins:[publicFunClass],
    data() {
      return {
          emojiList: require('@/assets/emotion.json'),
          total: 0,
          pageSizeList:[10,20,30,40,50,100,200],
          currentPage:1,
          pageSize:20,
          tableHeight:{height:''},

          tabName:"1", //当前的tab名称
          searchName: "", //搜索客户名称
          channelList:[{"id":"-7", "value":"网页"}, {"id":"-8", "value":"微信"}, {"id":"-9", "value":"小程序"}], //渠道类型集合
          currentSessionId: '',  //当前会话的sessionId
          currentOpenId: '',  //当前会话的openId
          onlineInfos:[], //客户列表

      }
    },
    created(){
          this.tableHeight.height=this.mountHeight(178);
          this.init();
    },
    methods: {
        changeTab:function(tabName){
          this.tabName = tabName;
          this.searchName = "";
          this.init();
        },
        // 选中一个会话事件
        selectSession: function(openId, sessionId, unreadCnt){
          this.currentOpenId = openId;
          this.currentSessionId = sessionId;
          // 消息全部已读
          this.$store.getters.getOnlineInfoByOpenId(openId).leftInfo.unreadCnt = "0";
          this.$store.commit('delUnreadCnt', unreadCnt);
          this.$store.commit('removeGlobalNoticeMsgList', openId);
          // 调用接口已读
          let param = {
          "sessionId": this.currentSessionId,
          }
          let that = this;
          this.$http.post("chatInterface/doIsRead.json",param).then(function (res) {  //待处理客户查询
                let result=res.data.flag;
                if(result!="666"){
                  that.$Modal.info({
                    title:'提示',
                    content:res.data.msg
                  });
                  return false;
                }
          });

          this.$emit("callbackFun", openId);
        },
        // 邀请会话
        inviteSession: function(sessionId, openId){
          this.$Modal.confirm({
            title: '提示',
            content: "是否邀请会话",
            onOk: () => {
              let param = {
                  "sessionId": sessionId,
                  journalType:"排队中邀请会话",
                  menuId:"null",
                }
                let that = this;
                this.$http.post("chatInterface/doInvitationWaitCaht.json",param).then(function (res) {  //邀请客户接口
                      let result=res.data.flag;
                      if(result!="666"){
                        that.$Message.error(res.data.msg);
                        return false;
                      }
                      that.$Message.success("邀请成功");
                      // 移动到待处理客户中  会话类型0默认排队1已分配2转接会话3多方会话
                      let onlineInfo = that.$store.getters.getOnlineInfoByOpenId(openId);
                      if(onlineInfo){
                        onlineInfo.leftInfo.sessionType = "1";
                        onlineInfo.sessionType = "1";
                        // 停止定时器
                        if(onlineInfo.leftInfo.queueTimeFun){
                          clearInterval(onlineInfo.leftInfo.queueTimeFun);
                        }
                      }
                      // 排队汇总的访客会有一条接入请求会话未读，邀请成功会导致未读消息会少一条，这里加上这条未读消息
                      // that.$store.commit('addUnreadCnt',1);
                      // that.changeTab("1");
                });
            }
          });
        },

        // 选中之后
        handleSelect(selectItem) {

        },
        init: function(openId){
          // 先查看本地有没有值
          this.onlineInfos = this.$store.getters.getOnlineInfos();
          // if(onlineInfos.length <= 0){
            //这里不再重新请求数据，已在签入成功时处理
            // let param = {
            //   journalType:"null",
            //   menuId:"null",
            //   type: '3',  //1待处理 2排队中
            //   pageNum: "0",
            //   pageSize: "0",
            // }
            // let that = this;
            // this.$http.post("chatInterface/toWaitDeal.json",param).then(function (res) {  //待处理客户查询
            //   let result=res.data.flag;
            //   if(result!="666"){
            //     that.$Modal.info({
            //       title:'提示',
            //       content:res.data.msg
            //     });
            //     return false;
            //   }
            //   // 将所有未读消息清空
            //   let contentList = res.data.obj.list.content;
            //   // 循环放到本地中
            //   contentList.forEach(item => {
            //     that.$store.commit('pushOnlineLeftInfo',item);
            //   });
            // })
        },
          //设备信息页面显示数量改变
        changeSize(event) {
          this.currentPage=1;
          this.pageSize=event;
          this.initSearch();
        },
        //设备信息当前页改变
        changeCurrent(event) {
          this.currentPage=event;
          this.initSearch();
        },
        htmlToString:function (sHtml) {
          return sHtml.replace(/[<>&"]/g,function(c){return {'<':'&lt;','>':'&gt;','&':'&amp;','"':'&quot;'}[c];});
        },
        // 表情替换
        replaceEmoji(lastMsg){
            if(lastMsg && lastMsg.indexOf('/:') > -1){
              for(let i = 0; i < this.emojiList.length; i++){
                  for(let n = 0; n < this.emojiList[i].length; n++){
                      let newChar = this.htmlToString(this.emojiList[i][n].chars);
                      lastMsg = lastMsg.replace(new RegExp(RegExp.escape(newChar),'g'),"[表情]");
                  }
              }
            }
            return lastMsg;
        },
        resetCurrentId: function(openId){
          this.currentOpenId = openId;
        }
    },
    mounted() {
      RegExp.escape= function(s) {
        return s.replace(/[-\/:\\^$*+?.()|[\]{}><@&]/g, '\\$&');
      };
    },
    watch:{
    }

  }
</script>
<style scoped lang="less">

.leftlist .ivu-tabs-bar{
  margin-bottom: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/OnlineService/OnlineLeftcon.vue